import React from 'react';
import { connect } from 'react-redux';

import RoutingAx  from 'app/actions/routing';
import Link       from 'app/components/common/link';
import Modal      from 'app/components/common/modal';
import RoutingSlx from 'app/selectors/routing';

class ModalConfirmNav extends React.PureComponent {

  constructor(props) {
    super(props);

    this.onClickStay = this.onClickStay.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
  }

  onClickStay() {
    this.props.cancelNav();
  }

  onCloseModal() {
    this.props.cancelNav();
  }

  render() {
    const {targetUrl, currentPath} = this.props;
    if (!targetUrl) return null;
    const isSamePage = targetUrl.startsWith(currentPath || '') || targetUrl.startsWith('?');
    return (
      <Modal className="modal-confirm-nav" onClose={this.onCloseModal}>
        <h1 className="modal-confirm-nav-h1">Wait!</h1>
        <p className="modal-confirm-nav-p">You have unsaved changes. Are you sure you want to {isSamePage ? 'continue' : 'leave this page'}?</p>
        <div className="modal-confirm-nav-actions">
          <Link href={targetUrl} skipConfirm={true} className="btn secondary small">Continue without Saving</Link>
          <button className="btn blue small" onClick={this.onClickStay}>Stay, Keep Editing</button>
        </div>
      </Modal>
    );
  }

}

const stateToProps = (state) => ({
  targetUrl: RoutingSlx.confirmNavTo(state),
  currentPath: RoutingSlx.path(state),
});

const dispatchToProps = (dispatch) => ({
  cancelNav: () => dispatch(RoutingAx.cancelNav()),
});

export default connect(stateToProps, dispatchToProps)(ModalConfirmNav);
